export default __webpack_public_path__ + "static/media/nike_dunks_mystry_page.f4061e4f.png";